<div [class.has-results]="plantIDs.length">
    <button
        mat-stroked-button
        color="primary"
        (click)="fileInput.click()">
        Select Image
    </button>
    <button
        mat-stroked-button
        color="accent"
        (click)="onTakePhoto()">
        Take Photo
    </button>

    <input
        #fileInput
        type="file"
        accept="image/*"
        hidden
        (change)="onFileSelected($event)" />

    <!-- Search -->
    <mat-form-field
        appearance="outline"
        class="search-field">
        <mat-label>Search</mat-label>
        <button
            mat-icon-button
            matSuffix
            (click)="onSearch()">
            <mat-icon>search</mat-icon>
        </button>
        <input
            matInput
            placeholder="Tulip"
            [(ngModel)]="searchQuery"
            (input)="onSearch()" />
        <mat-hint>Search by common name or species</mat-hint>
    </mat-form-field>
</div>

<!--Image/Search results-->
@if (plantIDs.length) {
    <app-plant-id-results
        [results]="plantIDs"
        infiniteScroll
        [scrollWindow]="false"
        [fromRoot]="false"
        [infiniteScrollDistance]="1"
        [infiniteScrollThrottle]="50"
        (scrolled)="onScroll()"
        (plantIDClick)="onPlantIDClick($event)" />
}
